import { useCallback, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useTimModalStore } from './useTimModalStore';
import appConfig from '../utils/config';

const TIM_BASE_URL = appConfig.timBaseUrl.replace(/\/$/, '');

/**
 * 登录后 5s 后台静默挂载 IM iframe，让红点提前工作。
 * 若用户提前点开 IM（TimModal 内会立即触发 doInitTim），定时器到达时
 * timLoaded 已为 true，直接跳过，不会重复挂载。
 */
export function useTimBackgroundInit() {
  const { isSignedIn } = useAuth();
  const { timLoaded, setTimReady } = useTimModalStore();

  const init = useCallback(() => {
    if (timLoaded || !isSignedIn) return;
    setTimReady(`${TIM_BASE_URL}/`);
  }, [timLoaded, isSignedIn, setTimReady]);

  useEffect(() => {
    if (!isSignedIn) return;
    const timer = setTimeout(init, 5000);
    return () => clearTimeout(timer);
  }, [isSignedIn, init]);
}
